import { capitalize, Typography } from "@mui/material";
import useAuth from "../hooks/useAuth";
import Avatar from "./Avatar";
import { styled, useTheme } from "@mui/material/styles";

export default function MyAvatar({ ...other }) {
  const {
    user: { user_profile, username },
  } = useAuth();

    const theme = useTheme();
  
  return (
    <Avatar
      src={user_profile?.profile_image}
      alt={username}
      {...other}
      style={{ textTransform: "capitalize" , backgroundColor: theme.palette.mode === 'dark' ? theme.palette.primary.main : theme.palette.grey[400],}}
    >
      {/* {username?.slice(0, 1)} */}
      {user_profile?.first_name?.slice(0,1)}{user_profile?.last_name?.slice(0,1)}
    </Avatar>
  );
}

export const MemberAvatar = ({ uri, name, variant, ...other }) => {
  return (
    <Avatar src={uri} alt={name} {...other} variant={variant}>
      <Typography>{name?.slice(0, 1)}</Typography>
    </Avatar>
  );
};
